
require('/var/lib/jenkins/workspace/pf-onboarding-ui_Release_0/src/node_modules/footer/footer.less');